import React, { useState } from "react";
import { useQuery } from "react-query";
import {
  deleteProduct,
  editProduct,
  getProducts,
} from "../../../MyApi/product";
import DataTable from "../../UI/table/DataTable";
import StatusBadge from "../../UI/statusBadge";
import TableActions from "../../UI/table/TableActions";
import LoadingSpinner from "../../UI/spinner";
import { useLocation, useNavigate } from "react-router-dom";
import { formatPrice } from "../../../utils/formatPrice";

const ProductInfo = ({ id, name, store_type }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const { data, isLoading, refetch, isFetching } = useQuery(
    ["getProducts", id, currentPage],
    () => getProducts({ store_id: id }, currentPage),
  );
  const navigate = useNavigate();
  const products = data?.data?.products || [];
  const totdalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;

  const productColumns = [
    {
      label: "ترتيب العرض",
      accessor: "id",
      render: (row) => <span style={{ color: "green" }}>#{row.id}</span>,
    },
    { label: "اسم المنتج", accessor: "name" },
    { label: " الفئة", accessor: "category.name" },
    {
      label: "صورة المنتج",
      accessor: "image",
      render: (row) => (
        <img
          style={{ color: "green" }}
          width={64}
          height={64}
          src={row.images[0]?.image_path}
          className="rounded-4"
        />
      ),
    },
    // { label: "صورة ", accessor: "image" },
    { label: "الوصف", accessor: "description" },
    {
      label: "وقت التحضير",
      render: (row) =>
        row.preparation_time
          ? `${row.preparation_time} ${row.preparation_time_unit || ""}`
          : "___",
    },
    { label: "أقصي كمية في السلة", accessor: "max_cart_quantity" },
    {
      label: "السعر",
      render: (row) =>
        row.price
          ? `${formatPrice(row.currency_factor, row.price)} ${row.symbol_currency || ""}`
          : "___",
    },
    { label: "الخيارات", render: (row) => row.product_options.length },
    { label: "الإضافات", render: (row) => row.add_ons.length },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          isLoading={isLoading}
          viewPermission={"view_product"}
          editPermission={"update_product"}
          deletePermission={"delete_product"}
          show={() => {
            navigate(`${process.env.PUBLIC_URL}/product/${row.id}`, {
              state: {
                from: location.pathname + location.search,
                tab: "products",
              },
            });
          }}
          refetch={refetch}
          edit={() => goToEditProduct(row.id)}
          deleteFn={deleteProduct}
          id={row.id}
          mutationKey={"deleteProduct"}
          togglePermission={"update_product"}
          toggleMutationKey={"toggle-update-product"}
          toggleFn={(id, status) =>
            editProduct({ _method: "PUT", product: { is_active: status } }, id)
          }
          is_active={row.is_active}
        />
      ),
    },
  ];
  const goToEditProduct = (productId) => {
    navigate(`/product/edit/${productId}`, {
      state: {
        from: location.pathname + location.search,
        tab: "products",
      },
    });
  };
  const goToStoreProducts = (id, name) => {
    const params = new URLSearchParams({
      store_id: id,
      store_name: name,
      store_type: store_type,
    });

    navigate(`/products/store?${params.toString()}`, {
      state: {
        from: location.pathname + location.search,
        tab: "products",
      },
    });

    console.log(
      { from: location.pathname + location.search },
      "location.state?.from store show",
    );
  };
  // navigate(
  //           `${process.env.PUBLIC_URL}/products/store?store_id=${id}&store_name=${name}`,
  //         )

  return (
    <div>
      <DataTable
        title={"المنتجات"}
        isLoading={isLoading}
        data={products}
        columns={productColumns}
        isFetching={isFetching}
        createPermission={"create_product"}
        onAddClick={() => goToStoreProducts(id, name)}
        actionLabel={"إضافة منتجات"}
        totalItems={totdalItems}
        currentPage={currentPage}
        itemsPerPage={lastPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default ProductInfo;
